// extracted by mini-css-extract-plugin
export var active = "_gw-7";
export var blink = "_gw-8";
export var dropDownSelector = "_gw-4";
export var dropDownWrapper = "_gw-3";
export var fakeCursor = "_gw-6";
export var fontSizeButton = "_gw-9";
export var formQuillEditor = "_gw-0";
export var pressed = "_gw-a";
export var qlBlank = "_gw-1";
export var textFormattingToolbar = "_gw-2";
export var textToolbarOption = "_gw-5";